module.exports = __webpack_public_path__ + "static/img/微信图片_20220722084154.4d5e858f.jpg";